import axios from "axios";
import { Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
export const amiGet = (p, params) => axios.get(`${API}/api/ami${p}`, { params }).then((r) => r.data);
export const amiPost = (p, body) => axios.post(`${API}/api/ami${p}`, body || {}).then((r) => r.data);
export const amiPatch = (p, body) => axios.patch(`${API}/api/ami${p}`, body).then((r) => r.data);
export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Unbekannter Fehler";

export const num = (v, d = 2) =>
  v === null || v === undefined || Number.isNaN(v) ? "–" : Number(v).toLocaleString("de-DE", { minimumFractionDigits: d, maximumFractionDigits: d });
export const usd = (v, d = 2) => (v === null || v === undefined ? "–" : `${num(v, d)} $`);
export const pct = (v, d = 2) => (v === null || v === undefined ? "–" : `${v > 0 ? "+" : ""}${num(v, d)} %`);
export const tsFmt = (ms) => (ms ? new Date(ms).toLocaleString("de-DE", { dateStyle: "short", timeStyle: "short" }) : "–");
export const isoFmt = (iso) => (iso ? new Date(iso).toLocaleString("de-DE", { dateStyle: "short", timeStyle: "short" }) : "–");

export function Kpi({ label, value, hint, tone, testid }) {
  const color = tone === "pos" ? "text-emerald-400" : tone === "neg" ? "text-rose-400" : "text-foreground";
  return (
    <div className="card-surface p-5" data-testid={testid}>
      <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className={`mt-2 font-mono text-xl ${color}`}>{value}</div>
      {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}

export function StatusDot({ ok, warn }) {
  const c = ok ? "bg-emerald-400" : warn ? "bg-amber-400" : "bg-slate-500";
  return <span className={`inline-block h-2 w-2 rounded-full ${c}`} aria-hidden />;
}

export function StatusRow({ label, value, ok, warn, testid }) {
  return (
    <div className="flex items-center justify-between gap-4 py-2.5 border-b border-border/60 last:border-0" data-testid={testid}>
      <span className="text-sm text-muted-foreground">{label}</span>
      <span className="flex items-center gap-2 text-sm text-right"><StatusDot ok={ok} warn={warn} />{value}</span>
    </div>
  );
}

export function Card({ title, children, actions, testid, className = "" }) {
  return (
    <section className={`card-surface p-6 min-w-0 ${className}`} data-testid={testid}>
      {(title || actions) && (
        <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
          <h2 className="font-heading text-base">{title}</h2>
          {actions}
        </div>
      )}
      {children}
    </section>
  );
}

export function NotYet({ text, testid }) {
  return (
    <div className="rounded-lg border border-dashed border-border px-4 py-3 text-sm text-muted-foreground" data-testid={testid}>
      {text}
    </div>
  );
}

export function Loading() {
  return <div className="py-10 grid place-items-center text-muted-foreground"><Loader2 className="h-5 w-5 animate-spin" /></div>;
}
